<template>
    <div id="user-fly-talks">
        <div class="fly-talks-title">Fly talks</div>
        <p class="fly-talks-description">
            Fly Talks su kratki razgovori između poslodavca i posjetitelja konferencije u opuštenoj atmosferi. 
            Poslodavce smo podijelili u 4 skupine, a ti biraš jednu ili više njih koje su ti najzanimljivije. 
            Odabirom skupine imat ćeš 8 minuta sa svakim od poslodavaca u njoj da se upoznate i vidite koliko 
            si međusobno odgovarate. Prijavi se, sekunda je potrebna, a možda se desi kemija.
        </p>
        <div class="fly-talks-cta">
            <div>
                <img src="../../assets/app-icons/home/job.svg" />
                <span>Pronađi posao</span>
            </div>
            <div>
                <img src="../../assets/app-icons/home/experience.svg" />
                <span>Obogati iskustva</span>
            </div>
            <div>
                <img src="../../assets/app-icons/home/networking.svg" />
                <span>Stekni vrijedna poznanstva</span>
            </div>
        </div>
        <div class="fly-talks-container">
            <div class="fly-talk" v-for="flyTalk in flyTalks" v-bind:key="flyTalk.id">
                <div class="fly-talk-title">
                    {{flyTalk.name}}
                </div>
                <div class="fly-talk-time">
                    {{flyTalk.starts | filterDateTimeFromDate}} - {{flyTalk.ends | filterTimeFromDate}}
                </div>
                <div class="fly-talk-box">
                    <div class="fly-talk-company-images">
                        <div v-for="eventCompany in flyTalk.eventCompanies" v-bind:key="eventCompany.companyId">
                            <template v-if="eventCompany.company">
                                <img v-bind:class="getCompanyNameNormalized(eventCompany.company.name)" v-bind:src="getCompanyLogo(eventCompany.company.name)" 
                                    v-bind:alt="`${eventCompany.company.name} logo`" />
                            </template>
                        </div>
                    </div>
                    <button v-bind:class="['fly-talks-apply', appliedFlyTalksIds.indexOf(flyTalk.id) === -1 && flyTalksDisabledIds.indexOf(flyTalk.id) !== -1 ? 'max-participants' : '']" 
                        v-bind:style="{visibility: new Date(flyTalk.starts) > new Date() ? 'visible' : 'hidden'}" v-on:click="applyOrRemoveFlyTalk(flyTalk.id)">
                        {{ appliedFlyTalksIds.indexOf(flyTalk.id) === -1 ? 'PRIJAVI SE' : 'IZBRIŠI PRIJAVU' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FlyTalks',
        data() {
            return {
                flyTalks: [],
                flyTalksDisabledIds: [],
                appliedFlyTalksIds: []
            }
        },
        methods: {
            getCompanyNameNormalized: function(companyName) {
                return companyName.replace(/\s/g, '').toLowerCase();
            },
            getCompanyLogo: function(companyName) {
                return require(`../../assets/companies/logos/${this.getCompanyNameNormalized(companyName)}.png`);
            },
            applyOrRemoveFlyTalk: function(eventId) {
                if(this.appliedFlyTalksIds.indexOf(eventId) === -1)
                {
                    if(this.flyTalksDisabledIds.indexOf(eventId) !== -1)
                    {
                        alert('Već je prijavljen maksimalan broj sudionika za taj događaj.');
                        return;
                    }

                    let userCv = prompt('Reci nam nešto o sebi (u max 1000 znakova), tako da tvrtke imaju osnovnu predodžbu o tebi. Napiši što god hoćeš' + 
                    '- radni status, iskustvo, hobije, na koji fakultet ideš... Kad budeš dolazio/la na razgovor, slobodno ponesi svoj CV za pokazati.');

                    if(userCv.length)
                        if(userCv.length <= 1000)
                            this.$axios.post(`${this.$API_URL}/user/apply`, {
                                eventId: eventId,
                                eventText: userCv    
                            }).then(() => {
                                alert('Prijava na fly talk uspješna!');
                                this.appliedFlyTalksIds.push(eventId);
                            }).catch(() => {
                                alert('Prijava na fly talk neuspješna. Nemaš dopuštenje ili je događaj već pun.');
                                return;
                            });
                        else
                            alert('Predug tekst! Molimo te pokušaj se ponovo prijaviti.');
                    else
                        alert('Ne možemo te pustiti da se prijaviš ako ne kažeš nešto o sebi. Molimo te pokušaj ponovo.');
                }
                else
                {
                    this.$axios.post(`${this.$API_URL}/user/remove-apply`, {
                        eventId: eventId   
                    }).then(() => {
                        alert('Odjava s događaja uspješna! Žao nam je što ipak nećeš doći :(');
                        this.appliedFlyTalksIds.splice(this.appliedFlyTalksIds.findIndex(id => id === eventId), 1);
                    }).catch(() => {
                        alert('Odjava s događaja neuspješna. Molimo te pokušaj opet.');
                        return;
                    });
                }
            }
        },
        created() {
            this.$axios.get(`${this.$API_URL}/events/fly-talks`).then(response => {
                this.flyTalks = response.data;
                for(let flyTalk of this.flyTalks)
                {
                    flyTalk.eventCompanies = flyTalk.eventCompanies.sort((firstEventCompany, secondEventCompany) => 
                        firstEventCompany.company.name < secondEventCompany.company.name ? -1 : 1);
                
                    this.$axios.get(`${this.$API_URL}/events/number-of-participants/${flyTalk.id}`).then(response => {
                        if(response.data >= flyTalk.maxParticipants)
                            this.flyTalksDisabledIds.push(flyTalk.id);
                    });
                }
            });

            this.$axios.get(`${this.$API_URL}/user/applied-fly-talks`).then(response => {
                this.appliedFlyTalksIds = response.data.map(flyTalk => flyTalk.id);
            });
        }
    }
</script>

<style scoped>
#user-fly-talks {
    margin-top: 20px;
    padding-left: 20px;
}

.fly-talks-title {
    font-size: 26px;
    font-weight: 800;
    line-height: 26px;
}

.fly-talks-description {
    margin-top: 20px;
    font-size: 14px;
    line-height: 25px;
    opacity: 0.75;
    padding-right: 20px;
}

.fly-talks-cta {
    margin-top: 30px;
}

.fly-talks-cta div {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
}

.fly-talks-cta div img {
    margin-right: 10px;
}

.fly-talks-cta div span {
    font-size: 14px;
    line-height: 17px;
    letter-spacing: -0.19px;
    font-weight: 800;
}

.fly-talks-container {
    display: flex;
    overflow-x: scroll;
    overflow-y: hidden;
    height: 320px;
    padding-bottom: 10px;
}

.fly-talks-container::after {
	content: '';
	flex: 0 0 10px;
}

.fly-talks-container .fly-talk {
    margin-top: 20px;
    flex: 0 0 200px;
    height: 250px;
    margin-right: 30px;
}

.fly-talk-box {
    background-color: white;
    padding: 20px;
    box-shadow: 0 4px 12px 0 rgba(0,0,0,0.06);
}

.fly-talk-company-images {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
}

.fly-talk-company-images div {
    flex: 0 0 80px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.fly-talk-company-images img {
    max-width: 100%;
    max-height: 100%;
}

.fly-talk-title {
    font-size: 16px;
    font-weight: 800;
    letter-spacing: -0.21px;
    line-height: 19px;
}

.fly-talk-time {
    font-size: 14px;
    letter-spacing: -0.16px;
    line-height: 25px;
    opacity: 0.3;
    margin-bottom: 20px;
}

.fly-talk-company-images img.atos,
.fly-talk-company-images img.bundesdruckerei {
    transform: scale(0.6);
}


.fly-talk-company-images img.ericssonnikolatesla {
    transform: scale(0.5);
}

.fly-talk-company-images img.rimacautomobili {
    transform: scale(1.4);
}

.fly-talk-company-images img.arsfutura,
.fly-talk-company-images img.profico,
.fly-talk-company-images img.lilcodelab {
    transform: scale(0.8);
}

.fly-talks-apply {
    border: none;
    font-size: 14px;
    font-weight: bold;
    color: white;
    background-color: #30cec1;
    padding: 7px 14px;
    border-radius: 5px;
    margin-left: 20px;
}

.fly-talks-apply:hover {
    cursor: pointer;
}

.fly-talks-apply.max-participants {
    opacity: 0.5;
}
</style>